import React from 'react';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';

function answerButton({
  actionIndex,
  actionIndexCarrousel,
  actionIndexSugestionsGeneral,
  index,
  indexCarrosuel,
  cardIndex,
  type
}: {
  actionIndex?: any;
  actionIndexCarrousel?: any;
  actionIndexSugestionsGeneral?: any;
  index?: any;
  indexCarrosuel?: any;
  cardIndex?: any;
  type?: string;
}) {
  useBgPages();

  const {
    t,
    register,
    watch,
    errors,
    handleRemoveAction,
    handleKeyDown,
    handleRemoveActionCard,
    handleRemoveSuggestion
  } = useFunctionsButtons();

  return (
    <React.Fragment
      key={`action-answer-${type === 'richCard' ? actionIndex : type === 'richCardCarrousel' ? actionIndexCarrousel : actionIndexSugestionsGeneral}`}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <SimpleTitle
          title="Respuestas"
          type="info fw-bolder"
          subtitle={`Botón ${type === 'richCard' ? actionIndex + 1 : type === 'richCardCarrousel' ? actionIndexCarrousel + 1 : actionIndexSugestionsGeneral + 1}`}
        />
        <button
          type="button"
          className="btn btn-link text-danger fw-bolder p-0"
          onClick={() => {
            if (type === 'richCard') {
              handleRemoveAction(index, actionIndex);
            } else if (type === 'richCardCarrousel') {
              handleRemoveActionCard(indexCarrosuel, cardIndex, actionIndexCarrousel);
            } else if (type === 'suggestionsGeneral') {
              handleRemoveSuggestion(actionIndexSugestionsGeneral);
            }
          }}
        >
          Eliminar
        </button>
      </div>
      {type === 'richCard' && (
        <div className="row">
          <div className="col-md-12">
            <Input
              label={t('templates.rcs.create.general-tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.gnlLabel`) as string)?.length || 0
              }
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.gnlLabel}
              {...register(`elements.${index}.actions.${actionIndex}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
        </div>
      )}
      {type === 'richCardCarrousel' && (
        <div className="row">
          <div className="col-md-12">
            <Input
              label={t('templates.rcs.create.url-tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`
                  ) as string
                )?.length || 0
              }
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.gnlLabel
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
            />
          </div>
        </div>
      )}
      {type === 'suggestionsGeneral' && (
        <div className="row">
          <div className="col-md-12">
            <Input
              label={t('templates.rcs.create.tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`) as string)?.length ||
                0
              }
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default answerButton;
